// extracted by mini-css-extract-plugin
export default {"root":"ReferenceTable__root__p2WH4","title":"ReferenceTable__title__ysQgF","subTitle":"ReferenceTable__subTitle__VhITG"};